import axios from 'axios'
import { KeycloakAuth } from '@/auth'
import { appConfig } from '@/config'

export * from './ingredients'
export * from './foodGroups'
export * from './recipes'

export const SEARCH_API_URL = appConfig.api.search
export const MEAL_PLANNER_API_URL = appConfig.api.mealPlanner

export const apiClient = axios.create({
  baseURL: appConfig.api.base,
})

apiClient.interceptors.request.use((config) => {
  config.headers.Authorization = 'Bearer ' + KeycloakAuth.fetch()
  return config
})

export type ApiError = {
  response: {
    data: {
      code: string
      message: string
    }
  }
}
